export const FORUM_STRUCTURE_REGULAR = 0;
export const FORUM_STRUCTURE_FEED = 1;
